import { useTranslation } from "react-i18next";

import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface FeatureProgressCardProps {
  featureId: string;
  runCount: number;
  creditsConsumed: number;
  categoryTotal: number;
}

export function FeatureProgressCard({
  featureId,
  runCount,
  creditsConsumed,
  categoryTotal,
}: FeatureProgressCardProps) {
  const { t } = useTranslation();

  const sharePercent =
    categoryTotal > 0
      ? Math.min((creditsConsumed / categoryTotal) * 100, 100)
      : 0;

  const label = t(`credits.features.${featureId}`, { defaultValue: featureId });

  return (
    <Card className="h-full">
      <CardContent>
        <p
          className="truncate text-sm font-medium text-muted-foreground"
          title={label}
        >
          {label}
        </p>
        <p className="mt-1 text-3xl font-semibold">
          {creditsConsumed.toLocaleString()}
        </p>
        <p className="text-xs text-muted-foreground">
          {runCount.toLocaleString()} {t("credits.runs").toLowerCase()}
        </p>
        <Progress value={sharePercent} className="mt-3 h-1.5" />
      </CardContent>
    </Card>
  );
}
